import axios from 'axios'

const axiosCommerceInstance = axios.create({})

axiosCommerceInstance.defaults.withCredentials = false
axiosCommerceInstance.defaults.headers.Accept = 'application/json'

export default axiosCommerceInstance
